<template>
  <div id="app">
    <template v-if="show">
      <el-container>
        <el-header height="56px">
          <header-page></header-page>
        </el-header>
        <el-container>
          <el-aside width="auto">
            <left-menu :list="menuList" :active="active"></left-menu>
          </el-aside>
          <el-container>
            <el-main>
                <header-breadcrumb :list="breadcrumbList"></header-breadcrumb>
                <router-view />
            </el-main>
          </el-container>
        </el-container>
      </el-container>
    </template>
    <template v-else>
        <router-view />
    </template>
   
  </div>
</template>

<script>
import headerPage from '@/components/header'
import leftMenu from '@/components/left-menu'
import headerBreadcrumb from "@/components/header-breadcrumb"
import {routes} from '@/router/router.config'

export default {
  name: 'App',
  components:{
    'header-page':headerPage,
    'left-menu':leftMenu,
    'header-breadcrumb':headerBreadcrumb
  },
  data(){
    return {
      menuList:[],
      breadcrumbList:[],
      active:'',
      show:false,
    }
  },
  watch:{
    '$route':{
      handler(to){
        this.show = to.path !== '/login'
        if(to.path !== 'login'){
          this.breadcrumbList = to.matched
          this.active = to.name
        }
      },
      deep:true
    }
  },
  created(){
    console.log(this.$router)
    this.getMenuList()
  },
  methods:{
    getMenuList(){
      this.menuList = routes.filter((item)=>{
        return item.meta.show
      })
    }
  }
}
</script>

<style>
html,body{
  margin: 0;
  padding: 0;
}
#app{
 height: 100vh;
 overflow: hidden;
}
.el-header{
  padding:0 !important;
}
.el-container{
  background-color: #E4E7EA;
}
.el-card__body, .el-main{
  padding: 0 !important;
}

.custom-marker-car{
  position: relative;
  width: 30px;
  height: 30px;
  background: url('./assets/icon/car.png') no-repeat;
  background-position: center center;
  background-size: 30px;
}

.custom-marker-poi{
  width: 30px;
  height: 30px;
  background: url('./assets/icon/drop.png') no-repeat;
  background-position: center center;
  background-size: 60px;
}

.select-marker-poi{
  width: 30px;
  height: 30px;
  background: url('./assets/poi-marker-red.png') no-repeat;
  background-position: center center;
  background-size: 20px;
}

.opi-info{
  display: none;
}
.opi-info > .poi-img{
  width:60px;
  height: 60px;
  border-radius: 8px;
}
.opi-info > .poi-name{
   margin-left: 8px;
}

.custom-marker-poi:hover > .opi-info{
  position: absolute;
  display: flex;
  top:-80px;
  left:-80px;
  padding: 10px;
  background-color: #ffffff;
  width:200px;
  height: 60px;
  border-radius: 20px;
}
.enable-btn{
  color:#F56C6C;
}
.enable-btn:hover{
  color:#F56C6C;
}
.map-image{
  width:50px;
  height: 50px;
  cursor: pointer;
}
.car-image{
  width:50px;
  height: 50px;
  cursor: pointer;
}
.clearfix .el-dialog__body {
  padding: 0 !important;
}

</style>



// WEBPACK FOOTER //
// src/App.vue